import React from 'react'
import styled from '@emotion/styled'

import { highlightBlueBase, fontWeightRegular, redLight10, fontSize2XSmall } from '../../constants/principles'

import Error from './Error'
import IneligibleDR from './IneligibleDR'

export default ({ isError, isAdmin, isDigitalRetail, isCobrandDR, kbbUrl = 'https://www.kbb.com', isAssigned, vin, year, make, model, trim, mileage = undefined, detail = 'style', isOfferCodeTcOffer }) => {
  return (
    <Error
      isError={isError}
      id={`ineligible-error`}
      testId={'bi-lb-ineligible-error'}
      text={`Based on the ${detail} shown above, this vehicle isn't eligible for an Instant Cash Offer${isDigitalRetail ? ', but the dealer might still take it as a trade in.' : '.'}`}>
      {isError && (
        <StyledCta>
          {!isAdmin && (isDigitalRetail || isCobrandDR) && !isOfferCodeTcOffer ? (
            <IneligibleDR reason={`${detail} is not eligible on this vehicle.`} vin={vin} year={year && year.yearId} make={make && make.makeId} model={model && model.modelId} trim={trim && trim.trimId} />
          ) : !isAssigned ? (
            <StyledA
              data-testid={'bi-btn-see-values'}
              href={`${kbbUrl}/vehicles/hub/pricingredirect/?vehicleId=${trim && trim.trimId}&intent=trade-in-sell&pricetype=trade-in&year=${year && year.displayName}&make=${make && make.displayName}&model=${model && model.displayName}&style=${trim &&
                trim.displayName}${mileage ? `&mileage=${mileage}` : ''}`}>
              See values
            </StyledA>
          ) : (
            <></>
          )}
        </StyledCta>
      )}
    </Error>
  )
}

const StyledCta = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightRegular};
  color: ${redLight10};
  display: 'flex';
  align-items: center;
  justify-content: center;
  text-align: center;
`
const StyledA = styled.a`
  text-decoration: none;
  color: ${highlightBlueBase};
  :hover {
    text-decoration: underline;
  }
`
